import { AIConversations } from "modules/aiConversations";

const AIConversationsPage = () => {
  return <AIConversations />;
};

export default AIConversationsPage;
